<template>
  <div>
    <el-card>
      <div class="add_box">
        <el-form
          :model="this.list"
          :rules="toEdRule"
          :label-position="labelPosition"
          ref="ruleForm"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="标题" prop="title">
                <el-input
                  placeholder="请输入内容"
                  v-model="list.title"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="18">
              <el-form-item label="摘要" prop="zhaiyao">
                <el-input
                  placeholder="请输入内容"
                  v-model="list.zhaiyao"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="长图" prop="ossUrl" ref="ossUrl">
                <el-upload
                  class="avatar-uploader"
                  :action="serverUrl"
                  :headers="header"
                  name="img"
                  :auto-upload="true"
                  :show-file-list="false"
                  :on-success="upSuccess"
                >
                  <img
                    v-if="list.oss_url"
                    :src="list.oss_url"
                    class="avatar"
                    style="width: 250px; height: auto"
                  />

                  <i
                    :class="
                      loadUpt
                        ? 'el-icon-loading'
                        : 'el-icon-plus avatar-uploader-icon'
                    "
                    style="margintop: 10px; font-size: 50px"
                    v-else
                  ></i>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="封面图" prop="coverUrl" ref="coverUrl">
                <el-upload
                  class="avatar-uploader"
                  :action="serverUrl"
                  :headers="header"
                  name="img"
                  :auto-upload="true"
                  :show-file-list="false"
                  :on-success="upSuccessCoverUrl"
                >
                  <img
                    v-if="list.cover_url"
                    :src="list.cover_url"
                    class="avatar"
                    style="width: 250px; height: auto"
                  />

                  <i
                    :class="
                      loadUpt
                        ? 'el-icon-loading'
                        : 'el-icon-plus avatar-uploader-icon'
                    "
                    style="margintop: 10px; font-size: 50px"
                    v-else
                  ></i>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-button
              style="margin-left: 600px"
              type="primary"
              @click="submitEdit('ruleForm')"
              >保存</el-button
            >
          </el-row>
        </el-form>
      </div>
    </el-card>
  </div>
</template>
<script>
import { baseURL } from "../../api/config";
export default {
  props: ["Changedata"],
  data() {
    return {
      loadUpt: false,
      list: [],
      myHeaders: { token: this.$store.state.token },
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
      myHeaders: { token: this.$store.state.token },
      labelPosition: "top",
      toEdRule: {
        title: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        // ossUrl: [
        //   { required: true, message: "内容不能为空", trigger: "blur" },
        // ],
        zhaiyao: [
          { required: true, message: "内容不能为空", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    upSuccess(file) {
      this.list.oss_url = file.entity;
      if (file.entity) {
        this.$refs.ossUrl.clearValidate();
      }
    },
    upSuccessCoverUrl(file) {
      this.list.cover_url = file.entity;
      if (file.entity) {
        this.$refs.ossUrl.clearValidate();
      }
    },
    submitEdit(formName) {
      this.$refs[formName].validate((valid) => {
        this.postAxios("/zidingyiPage/update", {
          id: this.list.id,
          ossUrl: this.list.oss_url,
          coverUrl: this.list.cover_url,
          title: this.list.title,
          zhaiyao: this.list.zhaiyao,
          mediaType: 1,
        }).then((res) => {
          if (res.success) {
            this.$message.success(res.message);
          } else if (res.success == false) {
            this.$message.error(res.message);
          } else if (res.success == false && res.statusCode == "401") {
            this.$message.error(res.message);
            this.$router.push("/");
          }
        });
      });
    },
  },
  mounted() {
    this.list = this.Changedata;
    console.log(this.list, "8");
    console.log(baseURL + "/file/uploadFile", "=======");
  },
  watch: {
    Changedata(newVal, oldVal) {
      this.list = newVal;
      console.log(newVal, "-------");
    },
  },
};
</script>
<style scoped lang="less">
/deep/.el-dialog {
  margin-top: 0 !important;
}
/deep/ .el-icon-close {
  font-size: 38px;
  font-weight: bold;
}
</style>